import { inject, Injectable, Signal } from '@angular/core';
import { injectDispatch } from '@ngrx/signals/events';
import { AuthFacade } from '@kikkz/shared/auth/data-access';
import { b04AuthEvents } from '@kikkz/b04/auth/util';
import { B04AuthStore } from '../store/b04-auth.store';

@Injectable()
export class B04AuthFacade extends AuthFacade {
  private readonly dispatchB04 = injectDispatch(b04AuthEvents);
  private readonly b04Store = inject(B04AuthStore);

  /** True when no token is available and login must be started explicitly via `login()` (on-demand mode). */
  readonly loginRequired: Signal<boolean> = this.b04Store.loginRequired;

  /** Starts the OAuth redirect. */
  login(): void {
    this.dispatchB04.initiateOAuthFlow();
  }

  loadTokensFromStorage(): void {
    this.dispatchB04.loadTokensFromStorage();
  }

  exchangeTokensForCode(code: string, state: string): void {
    this.dispatchB04.exchangeTokensForCode({ code, state });
  }
}
